'use strict';

exports.__esModule = true;
// This is an example of the actions for a component that the page will compose.
// It should export string constants for its action types (with a prefix e.g. SEARCH_BAR:GET_LOCATIONS)
// and use those in the action methods (e.g. getLocationAutocomplete).

// Things with API calls will use createAction as commented out below. See doctify/home-page.

// import { createAction } from 'doctify-utils';

var UPDATE_EMAIL = exports.UPDATE_EMAIL = 'LOGIN_ACTIONS:UPDATE_EMAIL';
var UPDATE_PASSWORD = exports.UPDATE_PASSWORD = 'LOGIN_ACTIONS:UPDATE_PASSWORD';
var REMEMBER_ME_TOGGLE = exports.REMEMBER_ME_TOGGLE = 'LOGIN_ACTIONS:REMEMBER_ME_TOGGLE';
var SET_VALID_EMAIL = exports.SET_VALID_EMAIL = 'LOGIN_ACTIONS:SET_VALID_EMAIL';
var LOGIN_VALIDATION_FAILED = exports.LOGIN_VALIDATION_FAILED = 'LOGIN_ACTIONS:LOGIN_VALIDATION_FAILED';

var pageActions = exports.pageActions = {
	updateEmail: function updateEmail(email) {
		return {
			type: UPDATE_EMAIL,
			email: email
		};
	},
	updatePassword: function updatePassword(password) {
		return {
			type: UPDATE_PASSWORD,
			password: password
		};
	},
	rememberMe: function rememberMe(rememberMeChecked) {
		return {
			type: REMEMBER_ME_TOGGLE,
			rememberMeChecked: rememberMeChecked
		};
	},
	setValidEmail: function setValidEmail(valid) {
		return {
			type: SET_VALID_EMAIL,
			valid: valid
		};
	},
	validationError: function validationError() {
		return {
			type: LOGIN_VALIDATION_FAILED
		};
	}
};


// WEBPACK FOOTER //
// ./components/login-page/lib/actions/page-actions.js